export default class GetContractsRequest {
    public deviceId: string = "";

    public includeAll: boolean = false;
}